import moment from "moment";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { cuesApi, timersApi } from "../../imports";
import { msToString } from "../helpers/time";
import BigTimeInternals from "./BigTimeInternals";

export default function BigTimeCountdown({
	cue,
	cloud,
	baseTheme,
	baseThemeId,
	cuePreview = false,
}) {
	const { projectId } = useParams();
	const [t, setT] = useState();
	

	useEffect(() => {
		let intervalId;
		clearInterval(intervalId);

		if (cue.state === "running") {
			intervalId = 
				setInterval(() => {
					let now = moment().format("x");
					let diff = cue.endAt - now;
					if (diff < 100 && ['onair', 'cuedoff'].includes(cue.status)) {
						switch (cue.onEnd) {
							case "hold":
								timersApi.countdownPause(cue.id, projectId, cue.endAt);
								break;

							case "reset":
								timersApi.countdownReset(cue.id, projectId, cue.duration);
								break;

							case "offair":
								cuesApi.updateCue(cue.id, projectId, { status: 'going', state: 'paused'});
								break

							default:
								break;
						}
					}
					setT(diff);
				}, 50)
			
		} else if (cue.state === "reset") {
			setT(cue.duration);
		}

		return () => {
			clearInterval(intervalId);
		};
	}, [cue.duration, cue.endAt, cue.id, cue.onEnd, cue.state, cue.status, projectId]);

	if (cuePreview) {
		return <>{msToString(t)}</>;
	}

	return (
		<BigTimeInternals
			cue={cue}
			time={t}
			cloud={cloud}
			baseTheme={baseTheme}
			baseThemeId={baseThemeId}
		/>
	);
}
